import { createContext, useContext } from "react";

type ReportingHubPageContextType = {
  refetch: Function;
  reportTemplates: any[];
  isLoading: Boolean;
};

export const ReportingHubPageContext = createContext<ReportingHubPageContextType | undefined>(undefined);

export const useReportingHubPageContext = (): ReportingHubPageContextType => useContext(ReportingHubPageContext);
